import React from "react";
import {
  Link,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Checkbox,
  FormControlLabel,
  useTheme,
} from "@material-ui/core";

import {guestmePushNotificationsOfferUrl} from "../../../config/constants";


export default function OfferConfirmationModal({
  handleClose,
  handleAccept,
}: {
  handleClose: () => void,
  handleAccept: () => void,
}) {
  const theme = useTheme();
  const [isOfferAccepted, setIsOfferAccepted] = React.useState(false);

  return (
    <div>
      <Dialog open onClose={handleClose}>
        <DialogTitle>Подключить интеграцию?</DialogTitle>
        <DialogContent
          dividers
          style={{
            paddingBottom: theme.spacing(1),
            color: "#323232",
          }}
        >
          <Box mb={2}>
            Работайте с&nbsp;гостями через мессенджеры&nbsp;&mdash;
            без&nbsp;отдельных договоров, интеграций и&nbsp;лишних настроек.
            Всё подключается и&nbsp;начинает работать буквально за&nbsp;пару минут!
          </Box>

          <Box mb={2}>
            Стоимость 1500&nbsp;рублей в&nbsp;месяц без&nbsp;ограничения
            на&nbsp;количество уведомлений.
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={isOfferAccepted}
                onChange={(event, checked) => setIsOfferAccepted(checked)}
              />
            }
            label={
              <>
                Согласен с&nbsp;
                <Link
                  href={guestmePushNotificationsOfferUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{color: "rgba(37, 80, 255, 1)"}}
                >Офертой</Link>
              </>
            }
          />
        </DialogContent>
        <DialogActions>
          <Box
            display="flex"
            flexDirection="row"
            width="100%"
            paddingX={2}
            paddingY={1}
          >
            <Box width="50%">
              <Button
                onClick={handleClose}
                variant="contained"
                style={{
                  paddingLeft: theme.spacing(3),
                  paddingRight: theme.spacing(3),
                }}
              >
                Отмена
              </Button>
            </Box>
            <Box width="50%" textAlign="right">
              <Button
                onClick={handleAccept}
                variant="contained"
                color="primary"
                style={{
                  paddingLeft: theme.spacing(3),
                  paddingRight: theme.spacing(3),
                }}
                disabled={!isOfferAccepted}
              >
                Подключить
              </Button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
